export var MessageDirection = /*#__PURE__*/ function(MessageDirection) {
    MessageDirection["ToPaywall"] = "to_paywall";
    MessageDirection["FromPaywall"] = "from_paywall";
    MessageDirection["ToPaywallUi"] = "to_paywall_ui";
    MessageDirection["FromPaywallUi"] = "from_paywall_ui";
    return MessageDirection;
}({});
// TODO Make sure messages? match incomingOutoing?
export const wrap = (message, messageDirection)=>{
    var events;
    if (!Array.isArray(message)) {
        events = [
            message
        ];
    } else {
        events = message;
    }
    const payload = {
        direction: messageDirection,
        version: 1,
        payload: {
            events
        }
    };
    return JSON.stringify(payload);
};
const buildNopValidator = ()=>{
    return {
        parse: (arg0)=>{
            return arg0;
        }
    };
};
export const unwrap = (message, messageDirection, validator = buildNopValidator())=>{
    try {
        let parsed = JSON.parse(message);
        let validated = validator.parse(parsed);
        if (validated.direction !== messageDirection) {
            throw new Error("Message direction incorrect");
        }
        return validated.payload.events;
    } catch (e) {
        console.log("failed to parse incoming message", message, e);
        return [];
    }
};
